import HeaderMenuMainButton from "src/libs/layout-app/header/HeaderMenuMainButton"
import HeaderUnderMenu from "src/libs/layout-app/header/HeaderUnderMenu"
import { getLandingContainer } from "../../../utils/getLandingContainer"
import { IMenuItem } from "src/libs/interfaces/layouts"
import { MenuContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"

const MenuMobileDefault = (props: IPrimitiveProps): JSX.Element => {  
    const primitive: MenuContent = ( props.primitive || {} ) as MenuContent
    const items: IMenuItem[] = primitive.items?.length  
        ?
        primitive.items
        :
        [] 
    const onRoute = (anchor: string) => { 
        setTimeout(() => {
            const element = document.getElementById( anchor.replace( "#", "" ) ) 
            getLandingContainer().scrollTo({
                behavior: "smooth",
                top: element?.getBoundingClientRect().top || 0,
            })
        }, 400)
    }
    return !!items.length 
        ?
        <> 
            <div className='flex-centered w-100 h-100 flex-column'>
                <div>
                {
                    items.map((item, i) => {
                        if ( Array.isArray(item.children) ) {
                            return <HeaderUnderMenu 
                                i={i} 
                                item={item} 
                                key={i} 
                                isForceOpen
                                header_menu={primitive.design_type || "inline"}
                                pt="0"
                                className={primitive.className}
                                style={{
                                    ...primitive.style,
                                    color: "var(--force-contast-color"
                                }}
                                onRoute={onRoute}
                            />
                        } 
                        return <HeaderMenuMainButton
                            item={ item }
                            i={ i }
                            key={ i } 
                            pt="0"
                            isForceOpen
                            header_menu={primitive.design_type || "inline"}
                            className={primitive.className}
                            style={{
                                ...primitive.style,
                                color: "var(--force-contast-color"
                            }}
                            onRoute={onRoute}
                        />
                    })
                }
                </div>  
            </div>  
        </>
        :
        <></>
}
export default MenuMobileDefault